import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import { useTheme } from "@mui/styles";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import useTranslation from "../../hooks/useTranslation";

const useStyles = (theme) => ({
  icon: {
    p: "5px",
    height: "14px",
    width: "14px",
    borderRadius: "58px",
    bgcolor: theme.palette.white.main,
    color: theme.palette.red.main,
    ml: "3px",
  },
  button: {
    borderRadius: "100px",
    color: theme.palette.white.main,
    bgcolor: theme.palette.red.main,
    fontSize: "16px",
    lineHeight: "28.8px",
    minHeight: "52px",
    width: "192px",
    textTransform: "none",
    "&:hover": {
      color: theme.palette.white.main,
      bgcolor: theme.palette.red.main,
    },
  },
});

const ApplyNowButton = ({ mb, mt }) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const navigate = useNavigate();
  const handleRedirect = () => {
    navigate("/aplica");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const { pathname } = useLocation();
  const { title } = useTranslation(pathname, "ApplyNowButton");

  return (
    <Button
      endIcon={<ArrowForwardIosIcon sx={classes.icon} />}
      variant="contained"
      sx={{ ...classes.button, mb, mt }}
      onClick={handleRedirect}
    >
      {title}
    </Button>
  );
};

export default ApplyNowButton;
